/* global axios */
import ApiClient from './ApiClient';

class ConversationPinsAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  pin(conversationId) {
    return axios.post(`${this.url}/${conversationId}/pin`);
  }

  unpin(conversationId) {
    return axios.delete(`${this.url}/${conversationId}/pin`);
  }
}

export default new ConversationPinsAPI();
